import { useEffect } from 'react';
import { getMyProfile } from '../services/supabase';

/**
 * While a user is signed in, checks (after 2 s, then every 30 s) that their
 * account is still active, and calls `onLogout` if an admin removed or
 * deactivated it. A network or server error is ignored on purpose: losing the
 * connection must never sign anyone out (see getMyProfile).
 */
export default function useUserActiveCheck(user, onLogout) {
  useEffect(() => {
    let cancelled = false;

    const checkUserStatus = async () => {
      if (!user) return;

      try {
        const currentUser = await getMyProfile();

        if (!cancelled && (!currentUser || !currentUser.isActive)) {
          if (onLogout) {
            onLogout();
          }
        }
      } catch (_) {
        // Ignore transient Supabase/network errors so users are not logged out spuriously.
      }
    };

    const initialTimeout = setTimeout(checkUserStatus, 2000);
    const interval = setInterval(checkUserStatus, 30000);

    return () => {
      cancelled = true;
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, [user, onLogout]);
}
